import { NotImplementedError } from "../errors";
import axios from "axios";
import { PromiseHandler } from "../handlers";
class Settings extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "settings");
    }
    /**
     * Find the default settings. Currenlty only supports returning all the settings.
     * @return: a promise that resolves with all default settings.
     */
    async findItems() {
        const res = await axios.get(`${this.sdk.urls.burnsBaseUrl}/settings/default`);
        return [res.data];
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("delete");
    }
}
export default Settings;
//# sourceMappingURL=settings.js.map